// ResultList.js - Module to generate a list of results

'use strict'
import $ from 'jquery';
import Result from './Result.js';
import ExpandIcon from './ExpandIcon.js';

// Helper function to remove an element from the DOM
Element.prototype.remove = function() { this.parentElement.removeChild(this); }
NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
    for(var i = this.length - 1; i >= 0; i--) {
        if(this[i] && this[i].parentElement) this[i].parentElement.removeChild(this[i]);
    }
}

class ResultList {
    constructor(data) {
        this.data = data;
        this.generateResults = this.generateResults.bind(this);
    }

    clean() {
        /*
        if(document.contains(document.getElementById('loading-gif'))) {
            document.getElementById('loading-gif').remove();
        }
        */
        document.getElementById("gif-background").style.display = "none";

        // Remove all child nodes from the result container if necessary
        let container = document.getElementById('results');
        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }
    }
    
    addCarbonValues() {
        // Function to add the total amount of carbon from all the legs of each flight
        const resultCount = this.data.body.trips.tripOption.length;

        // carbon-container-${i}
        for(let i = 0; i < resultCount; i++) {
            let carbon = 0;
            const carbonElem = document.getElementById(`carbon-container-${i}`);

            [].forEach.call(document.getElementsByClassName(`carbon-${i}`), function(elem) {
                if(elem.innerHTML.includes('?')) {
                    document.getElementById(`result-${i}`).invalidCarbon = true;
                    carbonElem.style.color = 'gray';
                } else {
                    let carbonAmount = elem.innerHTML;
                    carbonAmount = carbonAmount.substring(0, carbonAmount.indexOf('k') - 1);
                    carbon += +carbonAmount;
                }
            });

            carbonElem.innerHTML = `${carbon || '?'} kg CO${'2'.sub()}`;
        }
    }

    generateResults() {
        // Create each flight result element
        this.clean();
        /*
        // Modify the background
        const isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
        document.body.style.background = isSafari ?  '#eee' : `
            linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)),
            url('../assets/images/textures/agsquare.png')
        `;
        */
        document.body.style.background = "url('../assets/images/back_search.png') no-repeat center center fixed";

        // Error check
        if(!this.data.body.trips.tripOption) { 
            console.log("No flight search results found");
            //document.getElementById('error-box').innerHTML = "No flight search results found";
            return null;
        }

    
        // Result generation logic
        let container = document.getElementById('results');
        const resultCount = this.data.body.trips.tripOption.length;
        for(let i = 0; i < resultCount; i++) {
            const xIcon = new ExpandIcon(i);
            const resultData = this.data.body.trips.tripOption[i];
            const result = new Result(i, resultData, xIcon.getExpandIcon(), this.data);
            container.appendChild(result.getResult());
            // container.insertAdjacentHTML('beforeend', result.getResult());
        }
        return container;

    }
}

export default ResultList



// WEBPACK FOOTER //
// ./components/ResultList.js